

import { inject } from 'vue'
import SelectableParticipant from '../../BreakoutRoomsEditor/SelectableParticipant.vue'
import LoadingPlaceholder from '../../UIShared/LoadingPlaceholder.vue'
import Participant from './Participant.vue'

export default {
	name: 'ParticipantsList',

	components: {
		LoadingPlaceholder,
		Participant,
		SelectableParticipant,
	},

	props: {
		/**
		 * List of searched users or groups
		 */
		items: {
			type: Array,
			required: true,
		},

		loading: {
			type: Boolean,
			default: false,
		},

		isSearchResult: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['click'],

	setup(props) {
		const selectedParticipants = props.isSearchResult
			? inject('selectedParticipants', [])
			: undefined

		return {
			selectedParticipants,
		}
	},

	computed: {
		component() {
			return this.isSearchResult ? 'SelectableParticipant' : 'Participant'
		},

		token() {
			return this.$store.getters.getToken()
		},

		showUserStatus() {
			return this.items.length < 100
		},

		dummyParticipants() {
			const dummies = 6 - this.items.length
			return dummies > 0 ? dummies : 0
		},
	},

	methods: {
		async handleClickParticipant(participant) {
			this.$emit('click', participant)
		},

		generateKey(participant) {
			let key = ''
			if (participant.attendeeId) {
				// Attendee from participant list
				key = 'attendee#' + participant.attendeeId
			} else if (participant.source) {
				// Search result candidate
				key = 'search#' + participant.source + '#' + participant.id
			}
			return key
		},
	},
}
